var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8818 9.11621C11.3701 9.60449 11.3701 10.3975 10.8818 10.8857L4.63184 17.1357C4.14355 17.624 3.35059 17.624 2.8623 17.1357C2.37402 16.6475 2.37402 15.8545 2.8623 15.3662L8.22949 9.99902L2.86621 4.63184C2.37793 4.14355 2.37793 3.35059 2.86621 2.8623C3.35449 2.37402 4.14746 2.37402 4.63574 2.8623L10.8857 9.1123L10.8818 9.11621Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.c53a31b0105afa783f625fa35c65b38a.svg";
export { ForwardRef as ReactComponent };